import React, { Component } from 'react';
import { Modal, Row, Col } from 'antd';
import { observer, inject } from 'mobx-react';
import styles from './SyncModal.less';
import AccrossVersionsModal from './AcrossVersionsModal';
import moment from 'moment';

@inject('appStrategyStore')
@observer
class SyncModal extends Component {
  render() {
    const {
      SyncModalData,
      postStrategyProgress,
      currentStrategId,
      AcrossVersions,
      hideAcrossVersionsModal,
      SyncModalStatus,
      hideSyncModal
    } = this.props.appStrategyStore;
    return (
      <div>
        <Modal
          width={'50%'}
          className={styles.syncModalContainer}
          visible={SyncModalStatus}
          onOk={() =>
            postStrategyProgress(
              currentStrategId,
              'true',
              { ...SyncModalData }.useType === '1'
                ? { ...SyncModalData }.useTime.format('YYYYMMDDHH:mm:ss')
                : null
            )
          }
          onCancel={hideSyncModal}
          title="确认应用该策略?"
        >
          <Row className={styles.rowContainer}>
            <Col span={4}>应用方式:</Col>
            <Col span={4}>
              {{ ...SyncModalData }.useType === '1' ? '延时应用' : '立即应用'}
            </Col>
            {{ ...SyncModalData }.useType === '1' && (
              <Col span={16}>
                应用时间: &nbsp;{moment({ ...SyncModalData }.useTime).format(
                  'YYYY-MM-DD HH:mm:ss'
                )}
              </Col>
            )}
          </Row>
          <Row className={styles.listRow}>
            <Col span={8}>App名称</Col>
            <Col span={8}>版本</Col>
            <Col span={8}>是否为启动项</Col>
          </Row>
          {!!({ ...SyncModalData }.appList || []).length &&
            { ...SyncModalData }.appList.map((item, index) => (
              <Row key={item.name + index} className={styles.listRow}>
                <Col span={8}>{item.name}</Col>
                <Col span={8}>{item.current_version}</Col>
                <Col span={8}>否</Col>
              </Row>
            ))}
        </Modal>
        <AccrossVersionsModal
          status={AcrossVersions}
          hideFunc={hideAcrossVersionsModal}
          okFunc={() =>
            postStrategyProgress(
              currentStrategId,
              'false',
              { ...SyncModalData }.useType === '0'
                ? null
                : { ...SyncModalData }.useTime.format('YYYYMMDDHH:mm:ss')
            )
          }
        />
      </div>
    );
  }
}

export default SyncModal;



// WEBPACK FOOTER //
// ./src/components/AppStrategy/SyncModal.js